import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';
import { Button } from 'reactstrap';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css'; // Core styles
import 'ag-grid-community/styles/ag-theme-balham.css'; // Optional theme
import './ag-theme-ela.css';

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc', // Adds a light gray divider
  },
};

const columns = [
  {
    headerName: 'Final Conf',
    field: 'finalConfButton',
    width: 120,
    sortable: false,
    cellRenderer: 'finalConfCellRenderer',
  },
  {
    headerName: 'End Time',
    field: 'endTimeButton',
    width: 120,
    sortable: false,
    cellRenderer: 'endTimeCellRenderer',
  },
  {
    headerName: 'Job#',
    field: 'jobNum',
    width: 100,
  },
  {
    headerName: 'Date',
    field: 'jobDateTime',
    width: 120,
    cellRenderer: 'dateCellRenderer',
  },
  {
    headerName: 'Time',
    field: 'jobDateTime',
    width: 150,
    cellRenderer: 'timeCellRenderer',
  },
  {
    headerName: 'Claimant',
    field: 'clmLastName',
    width: 150,
    cellRenderer: 'claimantCellRenderer',
  },
  {
    headerName: 'Provider',
    field: 'providerName',
    width: 150,
    cellRenderer: 'providerCellRenderer',
  },
  {
    headerName: 'Address Info',
    field: 'aptStreet',
    width: 250,
    cellRenderer: 'addressCellRenderer',
  },
  {
    headerName: 'Appt Directions',
    field: 'intApptNotes',
    width: 200,
    cellRenderer: 'intApptNotesCellRenderer',
  },
  {
    headerName: 'Attachment',
    field: 'attachmentFileLocationS3',
    width: 120,
    sortable: false,
    filter: false,
    cellRenderer: 'attachmentCellRenderer',
  },
];

export class WorkOrderIntTableActive extends Component {
  static displayName = WorkOrderIntTableActive.name;

  constructor(props) {
    super(props);
    this.state = {
      columnWidths: columns.reduce((acc, col) => {
        acc[col.field] = col.width || DEFAULT_MIN_WIDTH_CELL; // Initialize widths
        return acc;
      }, {}),
    };

    // Bind methods
    this.autoSizeUnspecifiedColumns =
      this.autoSizeUnspecifiedColumns.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.onDataLoaded = this.onDataLoaded.bind(this);
    this.setData = this.setData.bind(this);
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  componentDidUpdate(prevProps) {
    // Check if the workOrders array has changed
    if (prevProps.workOrders !== this.props.workOrders) {
      if (this.gridApi) {
        // Update the grid with new data
        this.gridApi.setRowData(this.props.workOrders);

        // Force refresh of all cells
        this.gridApi.refreshCells({ force: true });

        console.log(
          'Grid data refreshed with new data:',
          this.props.workOrders
        );
      }
    }

    // Keep your existing code
    if (prevProps.selectedIndex !== this.props.selectedIndex) {
      this.setState({ selectedIndex: this.props.selectedIndex });
    }
    if (prevProps.searchModel !== this.props.searchModel) {
      this.setState({ searchModel: this.props.searchModel });
    }
  }

  // Method to handle sorting - implementing requestSort from original code
  requestSort = (field) => () => {
    const newSearchModel = { ...this.state.searchModel };
    if (newSearchModel.SortBy === field) {
      newSearchModel.SortDirection =
        newSearchModel.SortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      newSearchModel.SortBy = field;
      newSearchModel.SortDirection = 'asc';
    }

    this.setState({ searchModel: newSearchModel });

    if (this.props.onSortChanged) {
      this.props.onSortChanged(newSearchModel);
    }
  };

  // Method to handle Final Conf button clicks
  setData(workorder, index, isDoubleClick) {
    this.setState({ selectedIndex: index });
    if (this.props.onFinalConfClick) {
      this.props.onFinalConfClick(workorder, index, isDoubleClick);
    }
  }

  autoSizeUnspecifiedColumns = () => {
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      // Check if the width is not set in the column definition
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text'
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });

      maxHeight += 10;
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.setState({ gridApiReady: true });
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns(false);
  };

  onDataLoaded = (newData) => {
    this.gridApi.setRowData(newData);
    this.autoSizeUnspecifiedColumns(true);
  };

  onColumnResized = (params) => {
    if (params.finished) {
      // Update the state with new column width
      const newWidths = { ...this.state.columnWidths };
      params.columns.forEach((column) => {
        newWidths[column.getColId()] = column.getActualWidth();
      });
      this.setState({ columnWidths: newWidths }, () => {
        this.adjustHeaderHeight(this.gridApi);
      });
    }
  };

  render() {
    // Update column definitions to include current sort state

    const gridOptions = {
      suppressSizeToFit: false,
      columnDefs: columns,
      rowData: this.props.workOrders,
      context: {
        componentParent: this,
        gridApi: this.gridApi,
        state: this.state,
      },
      animateRows: true,
      defaultColDef: defaultColDef,
      onColumnResized: this.onColumnResized,
      components: {
        finalConfCellRenderer: FinalConfCellRenderer,
        endTimeCellRenderer: EndTimeCellRenderer,
        dateCellRenderer: DateCellRenderer,
        timeCellRenderer: TimeCellRenderer,
        claimantCellRenderer: ClaimantCellRenderer,
        providerCellRenderer: ProviderCellRenderer,
        addressCellRenderer: AddressCellRenderer,
        attachmentCellRenderer: AttachmentCellRenderer,
        intApptNotesCellRenderer: IntApptNotesCellRenderer,
      },
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      rowHeight: 33,
      getRowId: (params) => params.data.jobId,
      getRowClass: (params) =>
        params.rowIndex === this.state.selectedIndex ? 'selected-row' : '',
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '600px',
        }}
      >
        <AgGridReact {...gridOptions} onGridReady={this.onGridReady} />
      </div>
    );
  }
}

// Cell renderer for Final Conf button
class FinalConfCellRenderer extends Component {
  render() {
    const { data } = this.props;
    if (!data || data.finalConfButton === 'Hide') return null;

    return (
      <div style={{ textAlign: 'center', width: '100%' }}>
        <Button
          color="primary"
          size="sm"
          className="btn-portal-action"
          onClick={() => {
            // Access the parent component through context
            const componentParentProps =
              this.props.context.componentParent.props;
            if (componentParentProps && componentParentProps.setData) {
              componentParentProps.setData(data, true);
            } else {
              console.error('setData method not found in parent component');
            }
          }}
        >
          Final Conf
        </Button>
      </div>
    );
  }
}

// Cell renderer for End Time button
class EndTimeCellRenderer extends Component {
  render() {
    const { data } = this.props;
    if (!data || data.endTimeButton === 'Hide') return null;
    const componentParentProps = this.props.context.componentParent.props;
    return (
      <div style={{ textAlign: 'center', width: '100%' }}>
        <Button
          color="primary"
          size="sm"
          className="btn-portal-action"
          onClick={() =>
            componentParentProps.handleEndIntTimeClick(
              data,
              data.rowIndex,
              true
            )
          }
        >
          End Time
        </Button>
      </div>
    );
  }
}

// Cell renderer for Date column
class DateCellRenderer extends Component {
  render() {
    const { value } = this.props;

    if (!value) return '';
    return moment(value).format('MM/DD/YYYY');
  }
}

// Cell renderer for Time column
class TimeCellRenderer extends Component {
  render() {
    const { value, data } = this.props;
    if (!value) return '';

    // Format the start time from jobDateTime
    const startTime = moment(value).format('h:mm A');

    // Get finish time from the finishTime or finishTimeString property
    let finishTimeDisplay = '';

    // Check both finishTime (datetime) and finishTimeString (text representation)
    if (data.finishTime) {
      // Extract just the time portion from the finishTime datetime
      const finishTimeFormatted = moment(data.finishTime).format('h:mm A');

      // Only show if it's a valid time (not midnight default)
      if (finishTimeFormatted !== '12:00 AM') {
        finishTimeDisplay = ` to ${finishTimeFormatted}`;
      }
    }
    // Fallback to finishTimeString if available
    else if (data.finishTimeString && data.finishTimeString !== '00:00') {
      finishTimeDisplay = ` to ${data.finishTimeString}`;
    }

    // Debug log for checking data
    console.log(`Job ${data.jobNum} time data:`, {
      startTime,
      finishTime: data.finishTime,
      finishTimeString: data.finishTimeString,
      display: `${startTime}${finishTimeDisplay}`,
    });

    return `${startTime}${finishTimeDisplay}`;
  }
}

// Cell renderer for Claimant column
class ClaimantCellRenderer extends Component {
  render() {
    const { data } = this.props;
    if (!data) return '';
    const fullName = `${data.clmFirstName} ${data.clmLastName}`;
    return data.hasClaimantDupWO ? (
      <span style={{ color: 'red' }}>{fullName}</span>
    ) : (
      fullName
    );
  }
}

// Cell renderer for Provider column
class ProviderCellRenderer extends Component {
  render() {
    const { data } = this.props;
    if (!data) return '';
    return data.providerName || '';
  }
}

// Cell renderer for Address Info column
class AddressCellRenderer extends Component {
  render() {
    const { data } = this.props;
    if (!data) return '';
    return (
      <div>
        {data.aptStreet} {data.aptCity} {data.aptState} {data.aptZip}
      </div>
    );
  }
}

// Cell renderer for Interpreter Appt Directions
class IntApptNotesCellRenderer extends Component {
  render() {
    const { data } = this.props;
    if (!data || !data.intApptNotes) return null;
    return (
      <div style={{ whiteSpace: 'normal', lineHeight: '1.4' }}>
        {data.intApptNotes}
      </div>
    );
  }
}

// Cell renderer for Interpreter Attachment download link
class AttachmentCellRenderer extends Component {
  render() {
    const { data, context } = this.props;
    if (!data || !data.attachmentFileLocationS3) return null;
    return (
      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          context.componentParent.props.onDownloadAttachment(
            data.attachmentJobHistoryId,
            data.attachmentFileName
          );
        }}
      >
        Download
      </a>
    );
  }
}
